// @file Helpers for dealing with emojis
import { __ } from '@@/bits/intl'

const emojiCategories = ['people', 'nature', 'food', 'activity', 'travel', 'objects', 'symbols', 'flags']

const categoryTitles = {
  people: __('Smileys & People'),
  nature: __('Animals & Nature'),
  food: __('Food & Drink'),
  activity: __('Activity'),
  travel: __('Travel & Places'),
  objects: __('Objects'),
  symbols: __('Symbols'),
  flags: __('Flags'),
}

const categoryIcons = {
  people: 'smiley',
  nature: 'teddy',
  food: 'pizza',
  activity: 'ball',
  travel: 'car',
  objects: 'lightbulb',
  symbols: 'heart_outline',
  flags: 'flag_outline',
}

const categoryIconsOld = {
  people: 'mood',
  nature: 'cat',
  food: 'restaurant',
  activity: 'basketball',
  travel: 'directions_car',
  objects: 'lightbulb',
  symbols: 'favorite',
  flags: 'flag_outline',
}

const categorySelectedIcons = {
  people: 'smiley_filled',
  nature: 'teddy_filled',
  food: 'pizza_filled',
  activity: 'ball_filled',
  travel: 'car_filled',
  objects: 'lightbulb_filled',
  symbols: 'heart_filled',
  flags: 'flag_filled',
}

// Joypixel emojis
const COLD_FACE_EMOJI = {
  iconSrc: 'https://padlet.net/icons/6.6/svg/1f976.svg',
  iconAlt: __('Cold Face'),
}

const FACE_WITH_ROLLING_EYES_EMOJI = {
  iconSrc: 'https://padlet.net/icons/6.6/svg/1f644.svg',
  iconAlt: __('Face With Rolling Eyes'),
}

const WAVING_HAND_EMOJI = {
  iconSrc: 'https://padlet.net/icons/6.6/svg/1f44b.svg',
  iconAlt: __('Waving Hand'),
}

const OPEN_HANDS_ICON = {
  iconSrc: 'https://padlet.net/icons/6.6/svg/1f450.svg',
  iconAlt: __('Open hands'),
}

const WARNING_ICON = {
  iconSrc: 'https://padlet.net/icons/png/26a0.png',
  iconAlt: __('Warning'),
}

const ROBOT_FACE_EMOJI = {
  iconSrc: 'https://padlet.net/icons/png/1f916.png',
}

const INCOMING_ENVELOPE_EMOJI = {
  iconSrc: 'https://padlet.net/icons/png/1f4e8.png',
}

const SINGLE_PIXEL_PNG =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='

export {
  COLD_FACE_EMOJI,
  FACE_WITH_ROLLING_EYES_EMOJI,
  INCOMING_ENVELOPE_EMOJI,
  OPEN_HANDS_ICON,
  ROBOT_FACE_EMOJI,
  SINGLE_PIXEL_PNG,
  WARNING_ICON,
  WAVING_HAND_EMOJI,
  emojiCategories,
  categoryIcons,
  categoryIconsOld,
  categorySelectedIcons,
  categoryTitles,
}
